import AppState from '../states/app'

interface Calendar {
  id: string
  name: string
  groupId: string
}

interface Group {
  id: string
  name: string
}

interface ConflictingCalendarTableItem {
  name: string
  group: string
}

export function useConflictingCalendars() {
  const getConflictingCalendars = (
    selectedCalendarIds: string[],
    currentGroupId: string
  ) => {
    const allCalendars = AppState.globalCalendars?.calendars || []

    return (
      selectedCalendarIds
        ?.map(selectedId =>
          allCalendars.find(calendar => calendar.id === selectedId)
        )
        .filter(calendar => calendar && calendar.groupId !== currentGroupId) ||
      []
    )
  }

  const getConflictingCalendarsTable = (conflictingCalendars: Calendar[]) => {
    const allGroups = AppState.globalTeams?.teams || []

    return conflictingCalendars
      .map(calendar => {
        const groupName = allGroups?.find(g => g.id === calendar.groupId)?.name
        if (!groupName) {
          return null
        }

        return {
          name: calendar.name,
          group: groupName,
        }
      })
      .filter((item): item is ConflictingCalendarTableItem => item !== null)
  }

  return {
    getConflictingCalendars,
    getConflictingCalendarsTable,
  }
}
